import {
  RGSActions,
  K_CM_TRY_RECONNECT_SOCKET,
} from "./config/config.Connections";
import { action_updateServerStatus } from "./store/actions/actions.Game";
import {
  __App,
  __CurrentConnection,
  __ErrorManager,
  __HTMLEvents,
  __Lang,
  __Store,
  __UrlParams,
} from "../_core/core";
import * as ConnectionUtils from "./connections/marlipin/connection.Marlipin.utils";
import { ErrorSeverity } from "./core.ErrorManager";
import WebsocketConnection from "./connections/WebsocketConnection";
import { store } from "./core.Store";
import { ENABLE_LOGGING } from "../_game/config/Game";
import { Logger, LoggerEnums } from "./core.Logger";

class ConnectionManager {
  public connectionStrategy: any;
  private commandList: any;

  public currentCommand: any;
  public currentResponse: any;
  public bIsBusy: boolean;

  private heartbeatHandle: any;
  private lastErrCode: number;

  constructor() {
    // class that handles the RGS connection (HTTP or WEBSOCKET)
    this.connectionStrategy = null;
    // commands format {type: httpActions, data: object custom data}
    this.commandList = [];
    // callbacks
    this.onInit = this.onInit.bind(this);
    this.onReceive = this.onReceive.bind(this);
    this.onBroadcastReceive = this.onBroadcastReceive.bind(this);
    this.onSend = this.onSend.bind(this);
    this.handleUnexpectedMessage = this.handleUnexpectedMessage.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onError = this.onError.bind(this);
    // current command or null if no command is running
    this.currentCommand = null;
    // last received response in COMMON FORMAT
    this.currentResponse = null;
    // busy flag
    this.bIsBusy = false;
    // heartbeat handle
    this.heartbeatHandle = null;
    // last error code necessary for socket disconnects
    // If different than 0 then we don't try a reconnect
    this.lastErrCode = 0;
  }

  setConnectionStrategy(connectionStrategy: WebsocketConnection) {
    this.connectionStrategy = connectionStrategy;
    // delegate callbacks (receive, send, init)
    this.connectionStrategy.onReceive = this.onReceive;
    this.connectionStrategy.onBroadcastReceive = this.onBroadcastReceive;
    this.connectionStrategy.onSend = this.onSend;
    this.connectionStrategy.onInit = this.onInit;
    this.connectionStrategy.handleUnexpectedMessage =
      this.handleUnexpectedMessage;
    this.connectionStrategy.onClose = this.onClose;
    this.connectionStrategy.onError = this.onError;
  }

  // asks the manager to start the heartbeat sending with the specified payload (platform specific)
  // must be called once from the engine when you want it to start
  startHeartbeat() {
    let nInterval = this.connectionStrategy.getHeartbeatInterval();

    if (nInterval > 0) {
      // stop if started
      if (this.heartbeatHandle !== null) {
        clearTimeout(this.heartbeatHandle);
      }

      this.heartbeatHandle = setTimeout(() => {
        this.runCommand({
          type: RGSActions.HEARTBEAT,
          data: __CurrentConnection.getHeartbeatPayload(),
        });
        // start again
        this.startHeartbeat();
      }, nInterval);
    } else {
      if (this.heartbeatHandle !== null) {
        clearTimeout(this.heartbeatHandle);
      }
    }
  }

  // completely stop heartbeat
  stopHeartbeat() {
    if (this.heartbeatHandle !== null) {
      clearTimeout(this.heartbeatHandle);
    }
  }

  // resets heartbeat timer
  resetHeartbeat() {
    // stop
    this.stopHeartbeat();
    // start again
    this.startHeartbeat();
  }

  // returns last received response, should not be used... try using only state data
  getCurrentData() {
    return this.currentResponse;
  }

  // call this before anything
  init() {
    this.connectionStrategy.init();
  }

  onInit(_bSuccess: boolean) {
    // this.log('ConnectionManager::onInit(' + this.connectionStrategy.constructor.name + ') success:' + _bSuccess);
    /** @proxy - PROVIDER PROXY */
    // PROVIDER_PROXY.serverInit();
  }

  // command {type: eRGSAction, data: custom data for each action}
  // _dataToSend - actual data package that was sent
  onSend(_command: RGSActions, _dataToSend: any) {
    this.log(_dataToSend, true);
  }

  // is busy working on the queue?
  get isBusy() {
    return this.bIsBusy;
  }

  // handles all unexpected messages (heartbeat, platform commands, etc)
  handleUnexpectedMessage(_rcvPayload: any) {
    //send to
    ConnectionUtils.handleServerMessage(_rcvPayload);
  }

  onClose(event: any) {
    Logger({
      type: LoggerEnums.SYSTEM,
      errorMessage:
        "CM:: closed through onClose! eventClean:" +
        event.wasClean +
        " lastError:" +
        this.lastErrCode,
    });

    const lastErrCode =
      typeof event.code !== "undefined" ? event.code : this.lastErrCode;

    // special socket disconnect msgs
    if (K_CM_TRY_RECONNECT_SOCKET === false && __HTMLEvents.focus) {
      this.handleRedirect(lastErrCode, "onClose");
    }
  }

  isActive() {
    return this.connectionStrategy.isActive();
  }

  handleRedirect(error: number, where = "") {
    let disconnectUrl = __UrlParams.props.disconnectredirect;
    let _redirect = false;

    if (parseInt(__UrlParams.props.siteID) !== 30) {
      //LOGIN REDIRECT
      __ErrorManager.pushError(
        ErrorSeverity.CRITICAL,
        __Lang.translate("n:play.TEXT_CRITICAL"),
        -1,
        __Lang.translate("n:play.TEXT_WEBSOCKET_CLOSED")
      );
      return;
    }

    if (
      parseInt(__UrlParams.props.siteID) === 30 &&
      parseInt(__UrlParams.props.brandID) === 1
    ) {
      _redirect =
        disconnectUrl !== ""
          ? disconnectUrl
          : "https://www.lottogo.com/en?launch=4551";
    } else if (
      parseInt(__UrlParams.props.siteID) === 30 &&
      parseInt(__UrlParams.props.brandID) === 2
    ) {
      _redirect =
        disconnectUrl !== ""
          ? disconnectUrl
          : "https://www.lottogo.com.au/en?launch=4551";
    }

    if (_redirect) {
      //@ts-ignore
      return (window.top.location.href = _redirect);
      // switch (error) {
      //   //LOGIN ERROR
      //   case 13:
      //     //@ts-ignore
      //     return (window.top.location.href = _redirect);
      //   //OLD SESSION ERROR
      //   case 116:
      //     //@ts-ignore
      //     return (window.top.location.href = _redirect);
      //   //DUPLICATE SESSION ERROR
      //   case 33:
      //     //@ts-ignore
      //     return (window.top.location.href = _redirect);
      // }
    }

    __ErrorManager.pushError(
      ErrorSeverity.CRITICAL,
      __Lang.translate("n:play.TEXT_CRITICAL"),
      -1,
      __Lang.translate("n:play.TEXT_WEBSOCKET_CLOSED")
    );
  }

  onError(error: any) {
    Logger({
      type: LoggerEnums.SYSTEM,
      errorMessage: `CM:: [socket error]: ${error.message}`,
    });
  }

  onBroadcastReceive(_rcvPayload: any) {
    this.log(_rcvPayload, false);

    if (_rcvPayload.ERROR_CODE === 0) {
      //saves normalized state to store if no error
      __CurrentConnection.normalizeBroadcastResponse(_rcvPayload);
    }
  }

  // _rcvPayload - response in COMMON FORMAT
  onReceive(_rcvPayload: any) {
    // log output
    this.log(_rcvPayload, false);
    // don't do any processing when receiving a heartbeat
    // if we save/process it then it will mess up the data that we receive if the game was paused (minimized)
    if (_rcvPayload.COMMAND.type === RGSActions.HEARTBEAT) {
      if (_rcvPayload.COMMAND === this.currentCommand) {
        // reset current command
        this.currentCommand = null;
        // remove command from queue if executed correctly
        this.commandList.shift();
      } else {
        Logger({
          type: LoggerEnums.EXPECTED,
          errorMessage:
            "Expecting heartbeat but another command was found in the pipeline!",
        });
      }
      return;
    }

    // save current response
    this.currentResponse = { ..._rcvPayload };

    //console.log('xxx comparing commands:', _rcvPayload.COMMAND, this.currentCommand);
    if (_rcvPayload.COMMAND === this.currentCommand) {
      // reset current command
      this.currentCommand = null;
      // remove command from queue if executed correctly
      this.commandList.shift();
    } else {
      Logger({
        type: LoggerEnums.EXPECTED,
        errorMessage:
          "ConnectionManager::onReceive: received answer doesn`t correspond to launched command! Unexpected command?",
      });
    }
    // check for errors
    let lErrCode = _rcvPayload.ERROR_CODE;
    let lErrMsg = _rcvPayload.ERROR_MESSAGE;

    //check to see if we have error send from the platform
    let errorPayload = ConnectionUtils.getPayloadError(_rcvPayload);
    if (errorPayload.errCode !== 0) {
      _rcvPayload.ERROR_CODE = errorPayload.errCode;
      _rcvPayload.ERROR_MESSAGE = errorPayload.errMessage;
    }

    // save last error code
    this.lastErrCode = _rcvPayload.ERROR_CODE;

    // continue processing data
    if (_rcvPayload.ERROR_CODE === 0) {
      //saves normalized state to store if no error
      __CurrentConnection.normalizeResponse(_rcvPayload);
    } else {
      // we have error
      Logger({
        type: LoggerEnums.EXPECTED,
        errorCode: _rcvPayload.ERROR_CODE,
        errorMessage: _rcvPayload.ERROR_MESSAGE,
      });

      // CONNECTION FAILED
      if (_rcvPayload.ERROR_CODE === -1) {
        lErrCode = _rcvPayload.DATA.code;
        lErrMsg = _rcvPayload.DATA.message;
        // show the error popup disconnect
        // __ErrorManager.pushError(
        //   __Lang.translate("n:play.TEXT_CRITICAL"),
        //   __Lang.translate("n:TEXT_NOCONNECTION_TEXT"),
        //   lErrCode,
        //   lErrMsg
        // );

        this.handleRedirect(_rcvPayload.ERROR_CODE);
      } else {
        //generic server error
        lErrCode = _rcvPayload.DATA.code;
        lErrMsg = _rcvPayload.DATA.message;

        if (_rcvPayload.ERROR_CODE !== 81) {
          this.handleRedirect(_rcvPayload.ERROR_CODE, "onMessage 2");
        }

        // custom handled error (see getPayloadError)
        if (_rcvPayload.ERROR_CODE !== 0) {
          // custom popup gets shown, don't show default one
          if (
            [81, 115, 117, 113, 19].indexOf(
              _rcvPayload.ERROR_CODE as number
            ) !== -1
          ) {
            ConnectionUtils.handlePayloadError(errorPayload) as any;
            return;
          }
        }

        // show the error popup
        if ([13, 33, 116].indexOf(_rcvPayload.ERROR_CODE as number) === -1) {
          __ErrorManager.pushError(
            __Lang.translate("n:play.TEXT_CRITICAL"),
            __Lang.translate("n:TEXT_GENERIC_ERROR_TEXT"),
            lErrCode,
            lErrMsg
          );
        }
      }
    }
    //announce that we are not busy anylonger
    action_updateServerStatus(
      false,
      undefined,
      lErrCode,
      lErrMsg
    )(__Store.dispatch);

    //see if we still have elements in queue
    this.executeQueue();
  }

  runCommand(command: any, bInsertFirst: boolean = false) {
    if (bInsertFirst) {
      this.commandList.unshift(command);
    } else {
      this.commandList.push(command);
    }
    this.executeQueue();
  }

  // executes next command in queue
  executeQueue() {
    //console.log('execute queue called! comm:', this.currentCommand);
    //	see if we got disconnected but we have no error then we attempt a reconnect
    if (K_CM_TRY_RECONNECT_SOCKET) {
      if (
        this.connectionStrategy.isActive() === false &&
        this.lastErrCode === 0
      ) {
        // reconnect dead socket and run this executeQuery when done
        this.connectionStrategy.props.onReady = () => {
          this.executeQueue();
        };
        this.connectionStrategy.reconnectSocket();
        // get login command payload
        let pReLogin = ConnectionUtils.getLoginCommand(true);
        Logger({
          type: LoggerEnums.EXPECTED,
          errorMessage: `ConnectionManager:: Trying to reconnect websocket: ${pReLogin}`,
        });
        // add reconnect as first in commands list
        this.commandList.unshift(pReLogin);
        // reset current command so we try it again
        this.currentCommand = null;
        // early exit, wait for socket reconnect
        return;
      }
    }

    if (
      this.currentCommand === null &&
      this.commandList.length > 0 &&
      this.connectionStrategy.isActive() === true
    ) {
      // copy command
      this.currentCommand = { ...this.commandList[0] };
      // don't show as busy on heartbeat
      if (this.currentCommand.type !== RGSActions.HEARTBEAT) {
        // not a heartbeat, reset heartbeat timer
        this.resetHeartbeat();
        // show as busy so we block the interface
        action_updateServerStatus(true, this.currentCommand)(store.dispatch);
      }
      //getting busy
      this.bIsBusy = true;
      // run command
      let success = this.connectionStrategy.runCommand(this.currentCommand);
      if (success === false) {
        Logger({
          type: LoggerEnums.EXPECTED,
          errorMessage:
            "executeQueue: runCommand failed! executioner was busy!",
        });
      }
    }
    //signal when it stops being busy (queue empty)
    if (this.currentCommand === null && this.commandList.length === 0) {
      this.bIsBusy = false;
    }
  }

  dispose() {
    this.stopHeartbeat();
  }

  log(data: any, isFrontend: boolean = true) {
    if (!ENABLE_LOGGING) {
      return;
    }
    if (
      data.requestType === "heartbeat" ||
      (data.COMMAND && data.COMMAND.type === "HEARTBEAT")
    ) {
      if (isFrontend) {
        console.groupCollapsed(
          "%c HEARTBEAT FRONTEND                      ",
          "background: #844C9E; color: white; display: block;"
        );
      } else {
        console.groupCollapsed(
          "%c HEARTBEAT BACKEND                       ",
          "background: #4C9E9E; color: white; display: block;"
        );
      }
    } else {
      if (isFrontend) {
        console.groupCollapsed(
          "%c FRONTEND                                ",
          "background: #C14803; color: white; display: block;"
        );
      } else {
        console.groupCollapsed(
          "%c BACKEND                                 ",
          "background: #039005; color: white; display: block;"
        );
      }
    }

    console.log(data);
    console.groupEnd();
  }
}

export default ConnectionManager;
